import React, { useState, useEffect } from 'react';
import './Profile.css';
// import defaultImage from "../maamaaslog.png"; // Import image from src/assets
import Address from "./Address";
import { useNavigate } from "react-router-dom";
import Profilesub from "./Profilesub";
import { FaEdit, FaSave } from "react-icons/fa";
const Profile = () => {
   // const [image, setImage] = useState(defaultImage); // Set initial image from import
   const [isMobile, setIsMobile] = useState(false);
   const [loading, setLoading] = useState(true);
   const [error, setError] = useState(null);
   useEffect(() => {
      const checkMobile = () => setIsMobile(window.innerWidth <= 768);
      checkMobile(); // Run on mount
      window.addEventListener("resize", checkMobile); // Run on resize
      return () => window.removeEventListener("resize", checkMobile);
   }, []);
   const navigate = useNavigate();
   // State to store form data
   const [isEditing, setIsEditing] = useState(false);
   const [isSaving, setIsSaving] = useState(false);
   const [showBankDetails, setShowBankDetails] = useState(false);
   const base64Image = ""; // Assign a default value or set it dynamically

   const toggleBankDetails = () => {
      setShowBankDetails(!showBankDetails);
   };
   // const [image, setImage] = useState("path_to_default_image"); // Set default image here
   const [userDetails, setUserDetails] = useState({
      userName: "",
      emailId: "",
      mobileNumber: "",
      panCard: "",
      adhereCard: "",
      drivingLicense: "",
      image: "", // Updated field name for the image
   });
   const [userType, setUserType] = useState("user");
   const handleInputChange = (e) => {
      const { name, value } = e.target;
      setUserDetails((prevDetails) => ({
         ...prevDetails,
         [name]: value
      }));
   };

   const handleFileUpload = (event) => {
      const file = event.target.files[0]; // Get the selected file
      if (file) {
         const reader = new FileReader();
         reader.readAsDataURL(file); // Convert file to base64
         reader.onload = () => {
            setUserDetails((prevDetails) => ({
               ...prevDetails,
               passbookImage: reader.result, // Store base64 string in state
            }));
         };
      }
   };
   useEffect(() => {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("authToken"); // get auth token
      if (!userId) {
         console.error("User ID not found. User might not be logged in.");
         setError("User not logged in. Please log in first.");
         setLoading(false);
         return;
      }
      const apiUrl = `https://backend.maamaas.com/subscription/user/getprofile/${userId}`;
      const fetchUserData = async () => {
         try {
            const response = await fetch(apiUrl, {
               headers: token
                  ? { Authorization: `Bearer ${token}` }
                  : {},
            });

            if (!response.ok) {
               throw new Error("Failed to fetch data");
            }

            const data = await response.json();
            console.log("Fetched User Data:", data);

            setUserDetails({
               userName: data.userName || "",
               emailId: data.emailId || "",
               mobileNumber: data.mobileNumber || "",
               image: data.image || "", // Fetch the base64 image correctly
            });
         } catch (error) {
            console.error("Error fetching user data:", error);
            setError(error.message);
         } finally {
            setLoading(false);
         }
      };
      fetchUserData();
   }, []);

   // Function to handle image upload
   const handleImageChange = (event) => {
      const file = event.target.files[0];

      if (file) {
         const reader = new FileReader();
         reader.readAsDataURL(file);
         reader.onloadend = () => {
            const base64Image = reader.result.split(",")[1]; // Extract base64 without prefix

            // **Update UI Immediately**
            setUserDetails((prevDetails) => ({
               ...prevDetails,
               image: base64Image, // Using "image" field name
            }));

            // Call function to update profile image on the server
            updateProfileImage(base64Image);
         };
      }
   };
   // Function to update profile image using PUT API
   // Function to update profile image using PUT API
   const updateProfileImage = async (base64Image) => {
      const userId = localStorage.getItem("userId");
      const token = localStorage.getItem("authToken"); // get auth token

      if (!userId) {
         setError("User not logged in.");
         return;
      }
      const apiUrl = `https://backend.maamaas.com/subscription/user/editprofile/${userId}`;
      const payload = {
         userName: userDetails.userName,
         emailId: userDetails.emailId,
         mobileNumber: userDetails.mobileNumber,
         image: base64Image, // Use correct field name
      };

      try {
         const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
               "Content-Type": "application/json",
               ...(token && { Authorization: `Bearer ${token}` }), // Add token if exists
            },
            body: JSON.stringify(payload),
         });
         if (!response.ok) {
            throw new Error("Failed to update profile image.");
         }
         console.log("Profile image updated successfully.");
         // Optional: update token if returned in response headers
         const newToken = response.headers.get("authorization");
         if (newToken) {
            localStorage.setItem("authToken", newToken);
         }
      } catch (error) {
         console.error("Error updating profile image:", error);
         setError(error.message);
      }
   };
   // Handle the Edit button click
   const handleEditClick = () => {
      setIsEditing(true);
   };
   // Handle the Save button click
   const handleSaveClick = async () => {
      setIsSaving(true);
      try {
         const base64Image = userDetails.image;
         await updateProfileImage(base64Image); // Ensure image is updated
         setIsEditing(false);
      } catch (error) {
         console.error("Error saving user data:", error);
         setError(error.message);
      } finally {
         setIsSaving(false);
      }
   };
   return (
      <div

         style={{
            overflow: "auto",
            // height: "540px",
            // marginRight: "-197px",
            height: "auto",
            scrollbarWidth: "none", // For Firefox
            msOverflowStyle: "none", // For Internet Explorer & Edge
            marginTop: "11px"
         }}
         className='smallscreen' >
         <div className='container'>
            <div className='row' style={{ width: "100%" }}>
               <div className='col-lg-4 col-md-4 col-sm-12 col-12 profile-image-mobile'>
                  <div>
                     {/* Profile Image - Full Width on Mobile, Half Width on Larger Screens */}
                     <div style={isMobile ? { marginTop: "-60px" } : {}}>
                        <label htmlFor="imageUpload" style={{ cursor: "pointer" }}>
                           <img className='imgwidth imge-widt-date'
                              src={userDetails.image ? userDetails.image : "default-profile.png"}
                              alt="Profile"
                              style={{
                                 width: "223px",
                                 height: "204px",
                                 objectFit: "cover",
                                 // border: "2px solid rgb(177 93 198)",
                                 marginTop: "61px",
                                 paddingLeft: "2px",
                                 borderRadius: "40%"
                              }}
                           />
                        </label>
                        <input
                           type="file"
                           id="imageUpload"
                           accept="image/*"
                           style={{ display: "none" }}
                           onChange={handleImageChange}
                        />
                     </div>
                  </div>
               </div>
               <div className='col-lg-8 col-md-8 col-sm-12 col-12'>
                  {/* Form Fields - Below Image in Mobile, Side-by-Side in Larger Screens */}
                  <div>
                     <form>
                        {/* General User Fields - Display if not Delivery Partner */}
                        {userType !== "deliveryPartner" && (
                           <>
                              <div >
                                 <div style={{ width: "100%", marginBottom: "25px" }}>
                                    <input
                                       className="form-control"
                                       type="text"
                                       name="userName"
                                       value={userDetails.userName}
                                       onChange={handleInputChange}
                                       placeholder="Enter Your Name"
                                       disabled={!isEditing}
                                       style={{
                                          padding: "8px",
                                          fontSize: "15px",
                                          height: "50px",
                                          borderRadius: "10px",
                                       }}
                                    />
                                 </div>

                                 <div style={{ width: "100%", marginBottom: "25px" }}>
                                    <input
                                       type="email"
                                       name="emailId"
                                       value={userDetails.emailId}
                                       onChange={handleInputChange}
                                       placeholder="Enter Your Email"
                                       className="form-control"
                                       disabled={!isEditing}
                                       style={{
                                          padding: "8px",
                                          fontSize: "15px",
                                          height: "50px",
                                          borderRadius: "10px",
                                       }}
                                    />
                                 </div>

                                 <div style={{ width: "100%", marginBottom: "94px" }}>
                                    <input
                                       type="number"
                                       name="mobileNumber"
                                       value={userDetails.mobileNumber}
                                       onChange={handleInputChange}
                                       placeholder="Enter Your Mobile No."
                                       className="form-control"
                                       disabled={!isEditing}
                                       style={{
                                          padding: "8px",
                                          fontSize: "15px",
                                          height: "50px",
                                          borderRadius: "10px",
                                       }}
                                    />
                                 </div>
                              </div>
                           </>
                        )}
                        {/* Show additional fields if Delivery Partner is selected */}
                        {userType === "deliveryPartner" && (
                           <div className="diliverypatner-data" style={{ width: "100%" }}>
                              {/* Name Field */}
                              <div style={{ marginBottom: "25px" }}>
                                 <input
                                    type="text"
                                    name="userName"
                                    value={userDetails.userName}
                                    onChange={handleInputChange}
                                    placeholder="Enter Your Name"
                                    className="form-control"
                                    disabled={!isEditing}
                                    style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                 />
                              </div>

                              {/* Email Field */}
                              <div style={{ marginBottom: "25px" }}>
                                 <input
                                    type="email"
                                    name="emailId"
                                    value={userDetails.emailId}
                                    onChange={handleInputChange}
                                    placeholder="Enter Your Email"
                                    className="form-control"
                                    disabled={!isEditing}
                                    style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                 />
                              </div>

                              {/* Mobile Number Field */}
                              <div style={{ marginBottom: "25px" }}>
                                 <input
                                    type="number"
                                    name="mobileNumber"
                                    value={userDetails.mobileNumber}
                                    onChange={handleInputChange}
                                    placeholder="Enter Your Mobile No."
                                    className="form-control"
                                    disabled={!isEditing}
                                    style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                 />
                              </div>

                              {/* PAN Card Field */}
                              <div style={{ marginBottom: "25px" }}>
                                 <input
                                    type="text"
                                    name="panCard"
                                    value={userDetails.panCard}
                                    onChange={handleInputChange}
                                    placeholder="Enter Your PAN Card"
                                    className="form-control"
                                    disabled={!isEditing}
                                    style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                 />
                              </div>

                              {/* Aadhar Card Field */}
                              <div style={{ marginBottom: "25px" }}>
                                 <input
                                    type="text"
                                    name="adhereCard"
                                    value={userDetails.adhereCard}
                                    onChange={handleInputChange}
                                    placeholder="Enter Your Aadhar Card"
                                    className="form-control"
                                    disabled={!isEditing}
                                    style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                 />
                              </div>
                              {/* Driving License Field */}
                              <div style={{ marginBottom: "25px" }}>
                                 <input
                                    type="text"
                                    name="drivingLicense"
                                    value={userDetails.drivingLicense}
                                    onChange={handleInputChange}
                                    placeholder="Enter Your Driving License"
                                    className="form-control"
                                    disabled={!isEditing}
                                    style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                 />
                              </div>
                              <div style={{ marginBottom: "25px" }}>
                                 <input
                                    type="text"
                                    name="drivingLicense"
                                    value={userDetails.drivingLicense}
                                    onChange={handleInputChange}
                                    placeholder="Enter Your RC Details"
                                    className="form-control"
                                    disabled={!isEditing}
                                    style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                 />
                              </div>
                              {/* Toggle Button for Bank Details */}
                              <div style={{ marginBottom: "25px" }}>
                                 <button
                                    onClick={(event) => {
                                       event.preventDefault(); // Prevent page reload
                                       setShowBankDetails(!showBankDetails);
                                    }}
                                    className="btn btn-primary"
                                    style={{ borderRadius: "10px", padding: "10px", width: "100%", background: "#b15dc6" }}
                                 >
                                    Add Bank Details
                                 </button>
                              </div>
                              {/* Bank Details Section (conditionally rendered) */}
                              {showBankDetails && (
                                 <>
                                    {/* Account Holder Name */}
                                    <div style={{ marginBottom: "25px" }}>
                                       <input
                                          type="text"
                                          name="accountHolderName"
                                          value={userDetails.accountHolderName}
                                          onChange={handleInputChange}
                                          placeholder="Enter Account Holder Name"
                                          className="form-control"
                                          disabled={!isEditing}
                                          style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                       />
                                    </div>
                                    {/* Bank Name */}
                                    <div style={{ marginBottom: "25px" }}>
                                       <input
                                          type="text"
                                          name="bankName"
                                          value={userDetails.bankName}
                                          onChange={handleInputChange}
                                          placeholder="Enter Bank Name"
                                          className="form-control"
                                          disabled={!isEditing}
                                          style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                       />
                                    </div>
                                    {/* Account Number */}
                                    <div style={{ marginBottom: "25px" }}>
                                       <input
                                          type="text"
                                          name="bankAccountNumber"
                                          value={userDetails.bankAccountNumber}
                                          onChange={handleInputChange}
                                          placeholder="Enter Bank Account Number"
                                          className="form-control"
                                          disabled={!isEditing}
                                          style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                       />
                                    </div>
                                    {/* IFSC Code */}
                                    <div style={{ marginBottom: "25px" }}>
                                       <input
                                          type="text"
                                          name="ifscCode"
                                          value={userDetails.ifscCode}
                                          onChange={handleInputChange}
                                          placeholder="Enter IFSC Code"
                                          className="form-control"
                                          disabled={!isEditing}
                                          style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                       />
                                    </div>
                                    {/* Branch Name */}
                                    <div style={{ marginBottom: "25px" }}>
                                       <input
                                          type="text"
                                          name="branchName"
                                          value={userDetails.branchName}
                                          onChange={handleInputChange}
                                          placeholder="Enter Branch Name"
                                          className="form-control"
                                          disabled={!isEditing}
                                          style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                       />
                                    </div>
                                    {/* UAN Number */}
                                    <div style={{ marginBottom: "25px" }}>
                                       <input
                                          type="text"
                                          name="uanNumber"
                                          value={userDetails.uanNumber}
                                          onChange={handleInputChange}
                                          placeholder="Enter UAN Number"
                                          className="form-control"
                                          disabled={!isEditing}
                                          style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                       />
                                    </div>
                                    {/* Passbook Image Upload */}
                                    <div style={{ marginBottom: "25px" }}>
                                       <label>Upload Passbook Image</label>
                                       <input
                                          type="file"
                                          name="passbookImage"
                                          onChange={handleFileUpload}
                                          className="form-control"
                                          disabled={!isEditing}
                                          style={{ padding: "8px", fontSize: "15px", height: "50px", borderRadius: "10px" }}
                                       />
                                    </div>
                                 </>
                              )}
                           </div>
                        )}
                     </form>
                  </div>
               </div>
            </div>

            <div className='row'>
               <div
                  className="col-lg-12 col-md-12 col-sm-12 col-12"
                  style={isMobile ? { marginTop: "-100px" } : {}}
               >
                  <div style={{ display: "flex", justifyContent: "end", gap: "15px", marginTop: "0px", flexWrap: "wrap", }} className="profile-details-btns">
                     {!isEditing ? (
                        <button
                           className="btn btn-primary"
                           onClick={handleEditClick}
                           style={{
                              width: "35px",
                              background: "rgb(177 93 198)",
                              height: "30px",
                              fontSize: "18px",
                              display: "flex",
                              alignItems: "flex-start",  // Align icon to top
                              justifyContent: "center",
                              gap: "6px",                // Space between icon and text
                              paddingTop: "6px"          // Fine-tune top alignment
                           }}
                        >
                           <FaEdit style={{ fontSize: "18px" }} />
                        </button>
                     ) : (
                        <button
                           className="btn btn-primary"
                           onClick={handleSaveClick}
                           disabled={isSaving}
                           style={{
                              width: "35px",
                              background: "rgb(177 93 198)",
                              height: "30px",
                              fontSize: "18px",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "center",
                              gap: "6px",
                              paddingTop: "6px"
                           }}
                        >
                           <FaSave style={{ fontSize: "18px" }} />
                           {isSaving ? "..." : ""}
                        </button>
                     )}

                  </div>
               </div>
            </div>
            <div className='row'>
               <div
                  className="col-lg-12 col-md-12 col-sm-12 col-12"
                  style={isMobile ? { marginTop: "-50px" } : {}}>
                  <Address />
                  {/* <Profilesub /> */}
               </div>
               <div
                  style={{
                     position: "fixed",
                     bottom: "0px",
                     left: "0px",
                     height: '30px',
                     width: "100%",
                     backgroundColor: "white",
                     color: "black",
                     textAlign: "center",
                     padding: "5px",
                     fontWeight: "bold",
                     fontSize: "14px",
                     boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)",
                     zIndex: "999"
                  }}
               >
                  @Envision Integrated Services Pvt Ltd - Empowering Your Future 🚀
               </div>

            </div>
         </div>
      </div>
   );
};

export default Profile;
